/**
 * Whether a programme has retired, read against today in the tenant's zone.
 *
 * @module components/shared/programme-retirement
 */

import type { ProgrammeSummary } from "@/platform";
import { programmeRetired } from "@/server/programme-delivery-policy";
import { todayIn } from "@/utils/calendar-dates";
import { getRegion } from "@/utils/format-instant";

/** Today in the tenant's operating zone, the day an end of life is read against. */
export function regionToday(): string {
  return todayIn(getRegion().timeZone).toString();
}

/** Whether the programme has reached its end of life. */
export function isRetired(programme: Pick<ProgrammeSummary, "endOfLife">): boolean {
  return programmeRetired(programme.endOfLife, regionToday());
}
